// [FW-3982] Where a checkout autofill came from. FW-3293 keeps the buyer's data for whitelisted sellers
// even without "Simpan Data Pembeli" (saveDataHidden), but writes it to the same
// CheckoutCustomerInfo/CheckoutAddressInfo entries as that feature (saveData): the seller's automatic
// save or the buyer's "save" checkbox. So the path that wrote them is recorded next to them.
export const AUTOFILL_SOURCE = {
  SAVE_DATA: 'saveData',
  SAVE_DATA_HIDDEN: 'saveDataHidden',
  // Saved before the source was recorded, on a seller where either path could have written it
  UNKNOWN: 'unknown',
  NONE: 'none'
}

export const AUTOFILL_EVENT = {
  SAVE_DATA_HIDDEN_STORED: 'save_data_hidden_stored',
  CHECKOUT_AUTOFILLED: 'checkout_autofilled'
}

const AUTOFILL_SOURCE_STORAGE_KEY = 'CheckoutAutofillSource'

// Whether the buyer ticked the "save" checkbox on this page. It starts unticked and every click flips it.
// A whitelisted seller's submit still saves the data (FW-3293), but then it is the buyer's choice.
let saveDataChecked = false

export function toggleSaveDataChecked () {
  saveDataChecked = !saveDataChecked
}

export function isSaveDataChecked () {
  return saveDataChecked
}

// Analytics only: a storage failure here must not stop the checkout.
export function saveAutofillSource (domain, source) {
  try {
    localStorage.setItem(AUTOFILL_SOURCE_STORAGE_KEY, JSON.stringify({ [domain]: source }))
  } catch (e) {
    // Storage unavailable (private mode, full quota): the source is skipped, the checkout goes on.
  }
}

export function getAutofillSource (domain, isAutoFillForm) {
  let sources = null
  try {
    sources = JSON.parse(localStorage.getItem(AUTOFILL_SOURCE_STORAGE_KEY))
  } catch (e) {
    // An unreadable entry counts as no recorded source.
  }
  if (sources && sources[domain]) return sources[domain]
  // Only a whitelisted seller had the hidden save, so anyone else's older data came from Simpan Data Pembeli.
  return isAutoFillForm ? AUTOFILL_SOURCE.UNKNOWN : AUTOFILL_SOURCE.SAVE_DATA
}

// Field names only, never the buyer's values. Custom fields are named by the seller, so they are
// reported as "custom" rather than by their label.
export function getFilledFieldNames (requestedFields) {
  return (requestedFields || [])
    .filter(attr => attr.active && attr.value)
    .map(attr => (attr.isCustom ? 'custom' : attr.field))
    .filter((name, index, names) => names.indexOf(name) === index)
}
